import { Provider } from '@angular/core';

import { Types } from '../../../domain/types.domain';
import { SearchCnpjProvider } from '../../../infrastructure/providers/search-cnpj.provider';

export class SearchCnpjProviderInstruction {
  static provide(): Provider[] {
    return [
      {
        provide: Types.SearchCnpjProvider,
        useClass: SearchCnpjProvider,
      },
    ];
  }
}
